import { logger } from "utils/logger"

export const debug = (...msg: unknown[]) => logger.debug("WebAR", "debug", ...msg)
export const warn = (...msg: unknown[]) => logger.warn("WebAR", "warn", ...msg)
